import React, { FC } from 'react'
import { RadioButtonProps } from './types'
import {
  RadioButtonWrapper,
  RadioButtonInput,
  RadioButtonLabel,
  ErrorLabel,
} from './RadioButton.styles'

const RadioButton: FC<RadioButtonProps> = props => {
  const { error } = props
  return (
    <div>
      <RadioButtonWrapper removeMargins={props.removeMargins} marginWrapper={props.marginWrapper}>
        {/* @ts-ignore:next-line */}
        <RadioButtonInput type='radio' {...props} />
        <RadioButtonLabel
          htmlFor={props.id}
          bold={props.bold}
          display={props.display}
          ellipsis={props.ellipsis}
        >
          {props.label}
        </RadioButtonLabel>
      </RadioButtonWrapper>
      {error && <ErrorLabel>{error}</ErrorLabel>}
    </div>
  )
}

RadioButton.defaultProps = {
  disabled: false,
  removeMargins: false,
  ellipsis: false,
  error: '',
  label: '',
  value: '',
  size: 'm'
}

export default RadioButton
